import { render, staticRenderFns } from "./DetailExemptForm.vue?vue&type=template&id=7ac8d980"
import script from "./DetailExemptForm.vue?vue&type=script&lang=js"
export * from "./DetailExemptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports